"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _AdapterLuxon = require("@mui/x-date-pickers/AdapterLuxon");
var _luxon = require("luxon");
var _xDatePickers = require("@mui/x-date-pickers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var TableDateSearchBox = function TableDateSearchBox(_a) {
  var handleUpdateValue = _a.handleUpdateValue,
    _b = _a.defaultMinValue,
    defaultMinValue = _b === void 0 ? null : _b,
    _c = _a.defaultMaxValue,
    defaultMaxValue = _c === void 0 ? null : _c;
  var _d = (0, _react.useState)(defaultMinValue),
    minValue = _d[0],
    setMinValue = _d[1]; // Changing state triggers re-render
  var _e = (0, _react.useState)(defaultMaxValue),
    maxValue = _e[0],
    setMaxValue = _e[1]; // Changing state triggers re-render
  var lastTimeout = (0, _react.useRef)(); // Changing ref does not trigger render
  var handleUpdateValueCB = (0, _react.useRef)(handleUpdateValue);
  var defaultMinValueRef = (0, _react.useRef)(defaultMinValue);
  var defaultMaxValueRef = (0, _react.useRef)(defaultMaxValue);
  (0, _react.useEffect)(function () {
    // Ignore all initial renders
    if (defaultMinValueRef.current === minValue && defaultMaxValueRef.current === maxValue) return;
    if (defaultMinValueRef.current !== minValue) defaultMinValueRef.current = minValue;
    if (defaultMaxValueRef.current !== maxValue) defaultMaxValueRef.current = maxValue;
    lastTimeout.current = window.setTimeout(function () {
      handleUpdateValueCB.current(minValue && maxValue ? _luxon.Interval.fromDateTimes(minValue.startOf('day'), maxValue.endOf('day')) : null);
      clearTimeout(lastTimeout.current);
      lastTimeout.current = undefined;
    }, 300);
    return function () {
      if (lastTimeout.current != null) {
        clearTimeout(lastTimeout.current);
        lastTimeout.current = undefined;
      }
    };
  }, [minValue, maxValue]);
  return (0, _jsxRuntime.jsxs)("div", __assign({
    style: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: '2em',
      alignItems: 'stretch'
    }
  }, {
    children: [(0, _jsxRuntime.jsx)(_xDatePickers.LocalizationProvider, __assign({
      dateAdapter: _AdapterLuxon.AdapterLuxon
    }, {
      children: (0, _jsxRuntime.jsx)(_xDatePickers.DatePicker, {
        label: "start",
        value: minValue,
        onChange: function onChange(newValue) {
          // Clear the max date if the new min date is greater than the current max date
          if (maxValue && newValue && newValue > maxValue) {
            setMaxValue(null);
          }
          setMinValue(newValue);
        },
        renderInput: function renderInput(params) {
          return (0, _jsxRuntime.jsx)(_material.TextField, __assign({}, params, {
            style: {
              minWidth: '170px'
            }
          }));
        }
      })
    })), (0, _jsxRuntime.jsx)("span", __assign({
      style: {
        marginTop: '.5em',
        marginBottom: '.5em',
        textAlign: 'center'
      }
    }, {
      children: "to"
    })), (0, _jsxRuntime.jsx)(_xDatePickers.LocalizationProvider, __assign({
      dateAdapter: _AdapterLuxon.AdapterLuxon
    }, {
      children: (0, _jsxRuntime.jsx)(_xDatePickers.DatePicker, {
        label: "end",
        value: maxValue,
        onChange: function onChange(newValue) {
          // Clear the min date if the new max date is less than the current min date
          if (minValue && newValue && newValue < minValue) {
            setMinValue(null);
          }
          setMaxValue(newValue);
        },
        renderInput: function renderInput(params) {
          return (0, _jsxRuntime.jsx)(_material.TextField, __assign({}, params, {
            style: {
              minWidth: '170px'
            }
          }));
        }
      })
    }))]
  }));
};
TableDateSearchBox.propTypes = {
  handleUpdateValue: _propTypes.default.func.isRequired
};
var _default = TableDateSearchBox;
exports.default = _default;